// extracted by mini-css-extract-plugin
export default {"pageLoading":"LoadingPage_pageLoading__MOGWk","loadingImg":"LoadingPage_loadingImg__UYvQn","logoCirc":"LoadingPage_logoCirc__MXdeW","loadingTxt":"LoadingPage_loadingTxt__A3r5K"};